import Request from 'redux/config/services/Request'
import axios from 'axios'

export const getUploadFileUrl = async (contentType: string) => {
  const response = await Request.get(
    `/hr/tax_benefits/upload_receipt_url/?content_type=${contentType}`
  )
  return response
}

export const uploadFile = async (url: string, file: File) => {
  const response = await axios.put(url, file, {
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
    withCredentials: false,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    transformRequest: [(data) => data],
  })
  return response
}

export const getFileUploadUrl = async (id: string) => {
  const response = await Request.get(`/hr/tax_benefits/receipt_url/?key=${id}`)
  return response
}
